module.exports = __webpack_public_path__ + "static/intro_bg2-5bdc7bf75902713053b16dce0bbb5664.mp4";